module.exports = __webpack_public_path__ + "static/media/question.d5366fbc.svg";